import { computed, inject, Injectable, signal } from '@angular/core';
import { timer } from 'rxjs';
import { ReleaseNoteControllerService } from '@generated/backend-api/api/release-note-controller.service';
import { ReleaseNoteDto } from '@generated/backend-api/model/release-note-dto';
import { ReleaseNoteTypeEnum } from '@generated/backend-api/model/release-note-type-enum';

@Injectable({
  providedIn: 'root',
})
export class ReleaseNoteService {
  private readonly releaseNoteControllerService = inject(ReleaseNoteControllerService);

  public readonly allUnread = signal<ReleaseNoteDto[]>([]);
  public readonly unreadLarge = computed(() =>
    this.allUnread().filter((note) => note.type === ReleaseNoteTypeEnum.LARGE),
  );
  public readonly unreadSmall = computed(() =>
    this.allUnread().filter((note) => note.type === ReleaseNoteTypeEnum.SMALL),
  );

  constructor() {
    // Check for new release notes every 15 minutes
    timer(0, 15 * 60 * 1000).subscribe(() => {
      this.loadReleaseNotes();
    });
  }

  loadReleaseNotes() {
    this.releaseNoteControllerService
      .unread()
      .subscribe((releaseNotes) => this.allUnread.set(releaseNotes));
  }

  markAllAsRead() {
    this.markAsRead(this.allUnread());
  }

  markAsRead(readReleaseNotes: ReleaseNoteDto[]) {
    const ids = readReleaseNotes.map((r) => r.id).filter((id) => id !== undefined);
    this.releaseNoteControllerService.markAsRead(ids).subscribe(() => {
      this.loadReleaseNotes();
    });
  }
}
